import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  FormGroup,
  Field,
  Checkbox,
  CheckboxGroup
} from '@availity/form' 
import { Row, Col, Button } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class Strengths extends Component {

    constructor(props) {
      super(props);

      this.state = {
        redirectToHousingAssessment: false,
        redirectToHousingPreference: false,
        redirectToLandingPage: false,
      }

      if(window.performance) {
        if(performance.navigation.type == 1) {
          housingstore.resetSupportiveHousingPage();
          window.location.href = '#';
        }
      }
    }

    componentWillMount() {
      if (housingstore.getSupportiveHousingRouteStatus('/housingassessment') !== 'completed') {
        housingstore.resetSupportiveHousingPage();
        housingstore.resetSupportiveHousingRoutesStatus();
        this.setState({ redirectToLandingPage: true });
      } else if (
        housingstore.getSupportiveHousingRouteStatus('/strengths') !== 'completed' &&
        housingstore.getSupportiveHousingRouteStatus('/strengths') !== 'active'
      ) {
        housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
        housingstore.setSupportiveHousingRouteStatus('/strengths', 'active');
      }
    }
    
    componentDidMount() {
      window.onpopstate = () => {
        this.props.navigate(1); 
      }
    }

    getHousingAssessmentStrengths = value => {
      housingstore.setHousingAssessmentStrCategories(value);
    }

    setOtherStrengths = event => {
      const { value } = event.target;
      housingstore.updateOtherStrengths(value);
    }

    goBack = () => {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/strengths', 'inactive');
      this.setState({redirectToHousingAssessment: true});
    }

    submit = (pendingRoute = '/housingpreference') => {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/strengths', 'completed');
      if (pendingRoute === '/housingpreference') {
        this.setState({redirectToHousingPreference: true});
        return;
      }
      this.props.navigate(pendingRoute);
    }

  render() {

    const { redirectToHousingAssessment, redirectToHousingPreference, redirectToLandingPage } = this.state;

    const { otherStrengths, strengthsCategories, supportiveHousingPagesAHAH, supportiveHousingPagesNoAHAH, memberInfo } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if(redirectToHousingAssessment) {
      return <Navigate to="/housingassessment" />
    }

    if(redirectToHousingPreference) {
      return <Navigate to="/housingpreference" />
    }

    if(redirectToLandingPage) {
      return <Navigate to="/" />
    }

    return(
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm
            pages={supportiveHousingPages}
            initialValues={{
              strengthsCheckbox: strengthsCategories.map(x => x),
              otherStrengths: otherStrengths
            }}
            onSubmit={this.submit}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer" />
            <h2 className="poppinsH2">
                Housing assessment
            </h2>
            <h6 className="label-font">
                <i>Please fill out to the best of your ability. Information in this section assesses the individual’s housing preferences, needs and assets. This information does not impact eligibility. Identify individual traits that support the client’s ability to obtain and maintain housing. </i>
            </h6>
            <div className='spacer' />
            <div className="d-flex">
              <h5 className="poppinsH5">
                Strengths
              </h5>
              <p className="str-selectText">
                <em>Select all that apply:</em>
              </p>
            </div>
            <div className="titleSpacer" />
            <Row sm='12'>
              <Col className="strenghtCol" sm='4'>
                <CheckboxGroup name="strengthsCheckbox" value={strengthsCategories} onChange={this.getHousingAssessmentStrengths}>
                  <Checkbox
                    className="firstStrCol label-font mb-5 no-display"
                    label="Arranging apartment repairs"
                    name="arrangingApartmentRepairs"
                    value="Arranging apartment repairs"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Desire to work or engage in community activities"
                    name="desireToWorkOrEngageCommunityActivities"
                    value="Desire to work or engage in community activities"
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Driving/using public transportation"
                    name="drivingOrUsingPublicTransportation"
                    value="Driving/using public transportation"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Filling prescriptions"
                    name="fillingPrescriptions"
                    value="Filling prescriptions"
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Getting along with neighbors, landlords, etc."
                    name="gettingAlongWithNeighborsOrLandlords"
                    value="Getting along with neighbors, landlords, etc."
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Housekeeping"
                    name="housekeeping"
                    value="Housekeeping"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Hygiene"
                    name="hygiene"
                    value="Hygiene"
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Lease compliance"
                    name="leaseCompliance"
                    value="Lease compliance"
                  />
                </CheckboxGroup>
              </Col>
              <Col className="incomeSourceCol" sm="4">
                <CheckboxGroup name= "strengthsCheckbox" onChange={this.getHousingAssessmentStrengths}>
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Long-term rental history"
                    name="longTermRentalHistory"
                    value="Long-term rental history"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Maintaining benefits"
                    name="maintainingBenefits"
                    value="Maintaining benefits"
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Managing health care needs"
                    name="managingHealthCareNeeds"
                    value="Managing health care needs"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Managing/using caregivers"
                    name="managingOrUsingCaregivers"
                    value="Managing/using caregivers"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Meal preparation"
                    name="mealPreparation"
                    value="Meal preparation"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Money management"
                    name="moneyManagement"
                    value="Money management"
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Motivated to obtain housing"
                    name="motivatedToObtainHousing"
                    value="Motivated to obtain housing"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Motivated to resolve legal/credit issues"
                    name="motivatedToResolveLegalOrCreditIssues"
                    value="Motivated to resolve legal/credit issues"
                  />
                </CheckboxGroup>
              </Col>

              <Col sm="4" className="strenghtColEnd mb-0">
                <CheckboxGroup name= "strengthsCheckbox" onChange={this.getHousingAssessmentStrengths}>
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Paying bills"
                    name="payingBills"
                    value="Paying bills"
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Paying rent/utilities"
                    name="payingRentOrUtilities"
                    value="Paying rent/utilities"
                  />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    label="Shopping for food and necessities"
                    name="shoppingForFoodAndNecessities"
                    value="Shopping for food and necessities"
                  />
                  <Checkbox 
                    className="label-font mb-5 no-display"
                    label="Support from family/friends"
                    name="supportFromFamilyOrFriends"
                    value="Support from family/friends"
                  />
                  <Checkbox
                    className="label-font mb-2 no-display"
                    label="Taking medication"
                    name="takingMedication"
                    value="Taking medication"
                  />
                  <Checkbox 
                    className="label-font mb-2 no-display"
                    label="Other:"
                    name="other"
                    value="Other"
                  />
                </CheckboxGroup>
                {strengthsCategories.indexOf('Other') >= 0 && (
                  <FormGroup className="noMargin-buttom mt-2" for="otherStrengths">
                    <Field
                      type="textarea"
                      id="otherStrengths"
                      name="otherStrengths"
                      className="straighten-borders form-control form-group custom-OtherTextArea"
                      value={otherStrengths}
                      onChange={this.setOtherStrengths}
                      maxLength={200}
                    />
                    <p className="small text-right mb-0 label-font character-limit">200 Character max</p>
                  </FormGroup>
                )}
              </Col>  
            </Row>
            <div className="spacer-64" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(Strengths);

Strengths.propTypes = {
  navigate: PropTypes.func
};